import React from 'react';
import { Flex, Spinner } from '@banhala/ui-kit';

export const LoadingView: React.FC = () => {
  return (
    <Flex flex={1} alignItems={'center'} justifyContent={'center'}>
      <Spinner color={'content_pink_primary'} />
    </Flex>
  );
};
